import { useReducedMotion } from "framer-motion";

type Props = {
  variant?: "warm" | "sage" | "clay";
  className?: string;
};

/**
 * Restrained Olive-palette mesh: 2-3 soft radial blobs at low alpha,
 * slow drift via tailwind keyframes. Pure decoration, GPU-only.
 */
export const MeshGradient = ({ variant = "warm", className = "" }: Props) => {
  const reduced = useReducedMotion();
  const palette = {
    warm: ["hsl(var(--clay) / 0.12)", "hsl(var(--olive-soft) / 0.16)", "hsl(var(--sage) / 0.10)"],
    sage: ["hsl(var(--sage) / 0.30)", "hsl(var(--olive) / 0.22)", "hsl(var(--clay) / 0.10)"],
    clay: ["hsl(var(--clay) / 0.18)", "hsl(var(--clay) / 0.10)", "hsl(var(--olive-soft) / 0.10)"],
  }[variant];

  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 overflow-hidden -z-10 ${className}`}
    >
      <div
        className={`absolute -top-[20%] -left-[10%] size-[60vw] min-w-[420px] rounded-full blur-3xl ${reduced ? "" : "animate-drift-slow"}`}
        style={{ background: palette[0] }}
      />
      <div
        className={`absolute top-[20%] -right-[15%] size-[55vw] min-w-[420px] rounded-full blur-3xl ${reduced ? "" : "animate-drift-slow-alt"}`}
        style={{ background: palette[1] }}
      />
      <div
        className={`absolute -bottom-[20%] left-[25%] size-[45vw] min-w-[360px] rounded-full blur-3xl ${reduced ? "" : "animate-drift-slow [animation-delay:-14s]"}`}
        style={{ background: palette[2] }}
      />
    </div>
  );
};
